<template>
	
  <div class="home">
<div class="works-ban">
	
		<p> 
會員中心                              </p>
	</div>
   <div class="mem-full">
 <Center title='8' />
	
<div class="mem-con">
	
	<div class="mem-jin">
		
	
會員中心 / <b>帳戶安全</b>

	
		</div>
	<div class="cen-ord">
		
		
		  <div class="address">
		  	<div class="men-l1">
		  		<div class="re-tit">
				<h5>  {{user.email}}</h5>
				<div class="d1">
					<el-row>
						<el-col span="4">
							<div>安全等級： <span v-if="user.safe_number==100">高</span><span v-else>中</span></div>
						</el-col>
						<el-col span="9">
							<el-progress :text-inside="true" :stroke-width="16" :percentage="user.safe_number" color="#0A0A0A"></el-progress>
						</el-col>
					</el-row>
					
					
				</div>
		  		</div>
		  		<div class="re-con">
					<el-row class="lik" gutter="20">
						<el-col span="20">
							<h6>登入帳戶</h6>
							<p>它可以用來登入。它是您帳戶的唯一識別標記</p>
						</el-col>
						
						<el-col span="4">
						<router-link to="/user/email"><div class="h-but">修改</div></router-link>
						</el-col>
				 </el-row>
				 <el-row class="lik" gutter="20">
				 						<el-col span="20">
				 							<h6>登入密碼</h6>
				 							<p>為了確保您的購物安全，建議您定期更改密碼
保護你的帳戶安全</p>
				 						</el-col>
				 						
				 						<el-col span="4">
				 						<router-link to="/user/password"><div class="h-but">修改</div></router-link>
				 						</el-col>
				 </el-row>
				 <el-row class="lik" gutter="20">
				 				 						<el-col span="20">
				 				 							<h6>綁定手機</h6>
				 				 							<p>易於檢索密碼和驗證身份</p>
				 				 						</el-col>
				 				 						
				 				 						<el-col span="4">
				 				 						<router-link to="/user/info"><div class="h-button">驗證</div></router-link>
				 				 						</el-col>
				 				 </el-row>
						<el-row class="lik" gutter="20">
										 						<el-col span="20">
										 							<h6>驗證郵箱</h6>
										 							<p>您的電子郵寄地址:  {{user.username}}</p>
										 						</el-col>
										 						
										 						<el-col span="4">
										 							<router-link to="/user/mail"><div class="h-but">修改</div></router-link>
										 						</el-col>
										 </el-row>
		  		</div>
		  	</div>
	
		  </div>
	</div>


</div>
   </div>

    </div>
</template>
<script>

import Center from '@/components/center/center'

export default {
  components: {
   Center


  },
  data() {
    return {
		user:'',
		page:1,
		pagenum:100,
		moren:false,
		activeName: '1',
		sun:'',
		total:'',
		news:'',
           ruleForm: {
           	first_name:'',
           	last_name:'',
         
           	phone:'',
           	nickname:'',
           	country:'',
           	identity_id:'',
           	address_line:'',
           	province:'',
           	city:'',
           	postcode:'',
			moren: 0,
          
               
                 },
                 rules: {
                 	
                 	   first_name: [
                 	    { required: true, message: 'Please fill in First name', trigger: 'blur' },
                 ],last_name: [
                 	    { required: true, message: 'Please fill in Last name', trigger: 'blur' },
                 ],phone: [
                 	    { required: true, message: 'Please fill in Phone', trigger: 'blur' },
                 ],country: [
                 	    { required: true, message: 'Please fill in Country', trigger: 'change' },
                 ],address_line: [
                 	    { required: true, message: 'Please fill in Address Line 1', trigger: 'blur' },
                 ],province: [
                 	    { required: true, message: 'Please fill in Province', trigger: 'blur' },
                 ],city: [
                 	    { required: true, message: 'Please fill in City', trigger: 'blur' },
                 ],postcode: [
                 	    { required: true, message: 'Please fill in Postcode', trigger: 'blur' },
                 ],nickname: [
                 	    { required: true, message: 'Please fill in nickname', trigger: 'blur' },
                 ],identity_id: [
                 	    { required: true, message: 'Please fill in ID', trigger: 'blur' },
                 ]
                  
                   }
          };
  },  mounted() {
	 
	  this.id = this.$route.query.id

		this.sandMate();
		this.sandCase();
		},methods: {
			
		
			 receive(id){
			   	this.$axios({
			   	  method: "post",
			   	  url: "service.php?action=users_yhqLingqu",
			   	  data: {id:id},  
			   	}).then((res) => {
			   		let data=res.data;
			   	
			   		if(data.code==1){
			   			
			   		this.$message.success(data.message);
			
			   		}else{  
			   			this.$message.error(data.message);
			   			      
			   		}
			   	 
			   	});
			   
			   },
			 sandCase(){
			  	this.$axios({
			  	  method: "post",
			  	  url: "service.php?action=userAddress_country",
			  	  data: {},  
			  	}).then((res) => {
			  		let data=res.data;
			  	
			  		if(data.code==1){
			  			this.sun=data.data;
			  		}
			  	 
			  	});
			  
			  },pick(item){
							this.page=item;
							this.sandMate()
						},
			 sandMate(){
			 	this.$axios({
			 	  method: "post",
			 	  url: "service.php?action=users_userinfo",
			 	  data: {},  
			 	}).then((res) => {
			 		let data=res.data;
			 
			 		if(data.code==1){
			 	
			 							
			 			this.user=data.data;
						localStorage.setItem("user", JSON.stringify(data.data));
			 			
			 		}
			 	 
			 	});
			 
			 },
		      resetForm(formName) {
		        this.$refs[formName].resetFields();
		      }, handleClick() {
				  this.sandMate()
      
      }
		}
};
</script>
<style lang="scss" scoped>
	
	.h-button{
			text-align: center;
			cursor: pointer;
			height: 30px;
			line-height: 30px;
			background: #000;
			color: #FFFFFF;

		}
		.h-button:hover{
			background-color: #333333;
		}
	.login{
		padding: 20px 0;
		.re-tit{
			line-height: 50px;
			
			h4{
				font-size: 26px;
				
			}
			margin-bottom: 20px;
		}
	}	

.login-r1{

}
.login-r2{
	width:490px;

	padding: 50px;
	float: left;

}


	.works-ban{
		font-family: 'Arial-BoldMT';
		padding-top: 15px;
		background: #0A0A0A;
		height: 57px;
		color: #FFFFFF;
		text-align: center;
		line-height: 40px;
		font-size: 18px;
		font-weight: bold;
		h2{
			font-size: 43px;
		}
		span{
			margin: 20px;
			color: #B5B5B5;
		}
		.acts{
			color: #FFFFFF;
			font-weight: bolder;
		}
	}
	.h-but{
			text-align: center;
			cursor: pointer;
			height: 30px;
			line-height: 30px;
			background: #F8F8F8;
			color: #4E4E4E;
			border: 1px solid #E2E2E2;
	
		}
		.h-but:hover{
			background-color: #e0e0e0;
		}
.member{
	width: 247px;
	height: 687px;
	background: #F8F8F8;
	padding: 30px;
	h5{
		line-height: 50px;
		background: url(../../assets/bot1.png) no-repeat bottom left;
	}
	.con{
		li{
			border-bottom:1px solid #eeeeee;
			padding: 20px;
		}
		h6{
			line-height: 40px;
		}
		p{
			display: flex;
			line-height: 40px;
			align-items: center;
			color: #777777;
			span{
				display: inline-block;
				width: 6px;
				height: 6px;
				background: #636363;
				border-radius: 50%;
				margin-right: 10px;
			}
		}
		.act{
			color: #000000;
		}
	}

}
.mem-full{
	display: flex;
	width: 1200px;
	margin: 20px auto;
}

.mem-con{
	flex: 1;
	margin-left: 20px;
	.men-l1{
		border: 1px solid #D2D2D2;
		margin-bottom: 20px;
		.re-tit{
			padding: 20px;
			border-bottom: 1px solid #D2D2D2;
			background: #F8F8F8;
			h5{
				font-size: 24px;
			}
			h4{
				margin-left: 20px;
			}
			.d1{
				margin-top:10px;
				
			}
			
		}
		.re-con{
			padding:0 20px;
			.lik{
				border-bottom: 1px solid #E2E2E2;
				padding: 20px 0;
				
			}
			.coupon-li{
				width: 80px;
				text-align: center;
			}
			h6{
				font-size: 16px;
				margin-bottom: 10px;
			}
			p{
				font-size: 14px;
				line-height: 2;
			}
			.res-to{
				font-size: 16px;
				margin: 10px 0;
				
			}
		}
	}
}
.add-for{
padding: 30px;
	background: #F8F8F8;
	border: 1px solid #D2D2D2;
	

}
.add-ship{
	margin: 20px 0;
}
.add-set{
	margin-left: 10px;
}
.cen-ord1{
background: #F8F8F8;
padding: 20px;
margin-bottom: 20px;
}
.cen-ord2{
	width: 100%;
}
.cen-ord3{
	height: 100%;
	display: flex;
	flex-direction: column;
	justify-content:space-evenly;
}
	.page{
		text-align: center;
		margin:50px auto;
	}
	.mem-con-it{
		height: 100px;
	}
	.mem-ord-det{
		margin-top: 15px;
		text-decoration: underline;
	}

</style>